<template>
	<div class="flex h-fit md:min-h-[500px]">
		<div v-if="!isRedirecting" class="m-auto h-fit">
			<div class="mt-2 flex w-full flex-col">
				<h3>Weekly finance repayment estimate</h3>
				<div
					class="mt-2 space-y-2 text-base leading-tight text-gray-650"
				>
					<div class="text-sm">
						<span class="text-lg font-medium text-gray-900">
							{{
								formatCurrency(
									carClarityLoanDetails.weekly_loan_payment
								)
							}}
							per week
						</span>
						(calculated on "Excl. Govt Charges" price)
					</div>
					<div>
						{{ carClarityLoanDetails.customer_rate }}% interest rate
						| {{ carClarityLoanDetails.loan_interest_rate }}%
						comparison rate
						<sup>^</sup>
					</div>
					<div>{{ carClarityLoanDetails.loan_term }} year term</div>
					<div>{{ carClarityLoanDetails.balloon_pct }}% residual</div>
				</div>
			</div>
			<div class="mt-10 w-full">
				<div class="text-center text-gray-650 md:text-left">
					Get your top loan matches from 30+ lenders in 60 seconds
				</div>
				<div
					class="mt-3 flex w-full flex-col md:flex-row md:items-start md:justify-start md:space-x-4"
				>
					<div
						class="flex flex-col items-center gap-4 text-center md:flex-row"
					>
						<CarbarButton
							:disabled="isSubmitting"
							:show-loader="isSubmitting"
							:is-full-width="false"
							@click="goToRedirection"
						>
							Get my loan options
						</CarbarButton>
						<p class="text-sm text-gray-600">
							No impact on your credit score.
						</p>
					</div>
				</div>
				<div
					class="mt-5 flex w-full flex-row items-center justify-center space-x-2 md:w-auto md:justify-start"
				>
					<div>
						<span class="text-sm">Powered by</span>
					</div>
					<div>
						<CarbarImage
							image="img/logo-carclarity.webp"
							image-width-class="w-[100px]"
							alt-text="Car Clarity logo"
						/>
					</div>
				</div>
				<div class="mt-6 md:pr-[115px]">
					<TrustPilotMicro />
				</div>
			</div>
			<div class="mt-14 w-full text-justify text-sm text-gray-600">
				^ {{ carClarityLoanDetails.disclaimer }}
			</div>
		</div>
		<div
			v-if="isRedirecting"
			class="m-auto w-full space-y-8 pb-10 pt-10 md:pb-32 md:pt-24"
		>
			<div
				class="flex items-center justify-center space-x-4 md:space-x-6"
			>
				<div>
					<IconCarbarLogoBlue class="w-[110px] text-gray-500" />
				</div>
				<div>
					<IconArrowRightMenu class="h-7" />
				</div>
				<div>
					<CarbarImage
						image="img/logo-carclarity.webp"
						image-width-class="w-[100px]"
						alt-text="Car Clarity logo"
					/>
				</div>
			</div>
			<div class="mt-8 flex w-full justify-center">
				<p class="text-center text-sm text-gray-600">
					You are now being redirected from carbar to CarClarity
				</p>
			</div>
			<div
				class="mt-8 flex w-full flex-col justify-center gap-2 md:flex-row"
			>
				<CarbarButton
					:is-full-width="false"
					:background-color="'bg-blue-400 hover:bg-sky-600'"
					@click="onRedirectToCarClarity"
				>
					Proceed to CarClarity
				</CarbarButton>
				<CarbarButton
					:is-full-width="false"
					:is-outline="true"
					@click="onCancel"
				>
					Cancel
				</CarbarButton>
			</div>
		</div>
	</div>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarbarImage from '@/components/CarbarImage.vue'
import { useCarClarity } from '@/stores/car-clarity'
import TrustPilotMicro from '@/components/trustpilot/TrustPilotMicro.vue'
import IconCarbarLogoBlue from '@/assets/svg/logo-carbar-blue.svg'
import IconArrowRightMenu from '@/assets/svg/common/ico-arrow-right-menu.svg'

const carClarity = useCarClarity()

const props = defineProps({
	show: {
		type: Boolean,
		default: false,
	},
	carClarityLoanDetails: {
		type: Object,
		required: true,
	},
})

const isRedirecting = computed(() => carClarity.showRedirection)
const isSubmitting = computed(() => carClarity.isSubmitting)

const goToRedirection = () => {
	carClarity.goToRedirection()
}

const onRedirectToCarClarity = () => {
	carClarity.redirectToCarClarity()
	emit('proceedButton')
}

const emit = defineEmits(['cancelButton', 'proceedButton'])

const onCancel = () => {
	emit('cancelButton')
}
</script>
